import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss'
})
export class ConfirmationModalComponent {
  @Input() title: string;
  @Input() message: string;

  constructor(private activeModal: NgbActiveModal) { }

  yes() {
    this.activeModal.close(true);
  }

  no() {
    this.activeModal.dismiss();
  }

}
